module.exports = __webpack_public_path__ + "static/media/more_matches.1f9acaa7.svg";